export default __webpack_public_path__ + "static/media/documents-prosecutor.8a9ba81e.jpg";